module.exports = __webpack_public_path__ + "img/donante-tijuana.9da457be.jpeg";